module.exports = function getSearchPath() {
	const searchPath =
		process.env.CLF_SEARCH_CUSTOM_PATH && `${process.env.CLF_SEARCH_CUSTOM_PATH}`
			? `${process.env.CLF_SEARCH_CUSTOM_PATH}`
			: "/search";
	return {
		public: searchPath,
		private: `${process.env.CLF_PRIVATE_ROUTE}${searchPath}`,
	};
};
